// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qd3z","label":"styles_label__2A8Z0"};